<template>
  <DetailPage :name="modulename" :loading="loading" backRoute='moduleIntegral' :param="params">
    <template slot="detailMain">
      <span class="searchName">自定义时间段:</span>
      <el-date-picker v-model="tiemSlot" type="daterange" :clearable="false" size="large" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" class="kuang" style="width:250px;" @change="changeData"></el-date-picker>
      <el-button type="text" style="color:#2196F3"><a @click="downFile">导出</a></el-button>
      <div class="message">共{{count}}个命令模块&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;命令模块分数(总):{{jifen}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;已过滤0积分模块</div>
      <el-table :data="list" style="width: 100%;" height="545px" @sort-change="handleSortChange" highlight-current-row>
        <el-table-column type="index" label="序号" width="60">
          <template slot-scope="scope">
            <span>{{(pageNumber - 1) * pageSize + scope.$index + 1}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="moduleid" label="命令id" width="120" sortable="custom" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="modulename" label="命令模块名称" min-width="230" sortable="custom" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="cmdpoint" label="命令模块分数" width="130" sortable="custom" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="cmdtotalpoint" label="总积分" width="120" sortable="custom" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="allpoint" label="累计分数" width="120" sortable="custom" show-overflow-tooltip>
          <template slot-scope="scope">
            <span style="color:#669DF0">{{scope.row.allpoint}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="clicksNum" label="点击次数" width="120" sortable="custom" show-overflow-tooltip>
        </el-table-column>
      </el-table>
      <div class="footer">
        <el-pagination layout="sizes,prev, pager, next" :page-sizes="[10, 20, 30, 50,100]" @size-change="handleSizeChange" :page-size="pageSize" :current-page.sync="pageNumber" @current-change="changeData" :total="total" style="float: right">
        </el-pagination>
      </div>
    </template>
  </DetailPage>
</template>

<script>
import DetailPage from '@/components/DetailPage'
import { API__DailyStatistic } from '@/api/index.js'
export default {
  data() {
    return {
      loading: false,
      modulename: this.$route.query.modulename,
      tiemSlot: [this.$route.query.startData, this.$route.query.endDate],
      order: '',
      orderType: 'desc',
      showzero: 1,
      mokuais: [
        {
          value: 1,
          label: '显示不为0的数据',
        },
        {
          value: 2,
          label: '显示为0的数据',
        },
      ],
      count: this.$route.query.count,
      jifen: this.$route.query.jifen,
      token: '',
      checkCode: '',
      id: '',
      pageNumber: 1,
      pageSize: 20,
      total: 0,
      moduleid: this.$route.query.moduleid,
      list: [],
      params: {
        type: this.$route.query.type,
        pageNumber: this.$route.query.pageNumber,
        pageSize:this.$route.query.pageSize
      },
    }
  },
  components: {
    DetailPage,
  },
  mounted() {
    if (document.cookie.length > 0) {
      var arr = document.cookie.split('; ') //这里显示的格式需要切割一下自己可输出看下
      for (var i = 0; i < arr.length; i++) {
        var arr2 = arr[i].split('=') //再次切割
        //判断查找相对应的值
        if (arr2[0] == 'dnnyptadmin_token') {
          this.token = arr2[1] //保存到保存数据的地方
        } else if (arr2[0] == 'dnnyptadmin_checkCode') {
          this.checkCode = arr2[1]
        } else if (arr2[0] == 'dnnyptadmin_id') {
          this.id = arr2[1]
        }
      }
    }
    this.getData()
  },
  methods: {
    downFile(){
      let downHref =
        API__DailyStatistic.exportmodellist() +
        '?token=' +
        this.token +
        '&checkCode=' +
        this.checkCode +
        '&orderType=' +
        this.orderType +
        '&moduleid=' +
        this.moduleid +
        '&dBegin=' +
        this.$moment(this.tiemSlot[0]).format('YYYY-MM-DD') +
        '&dEnd=' +
        this.$moment(this.tiemSlot[1]).format('YYYY-MM-DD') +
        '&order=' +
        this.order +
        '&listType=page'+
        '&pageSize=9999'+
        '&pageNumber=1'+
        '&showzero=1'+
        '&modulename='+this.modulename


      const a = document.createElement('a')

      fetch(downHref)
        .then((res) => res.blob())
        .then((blob) => {
          // 将链接地址字符内容转变成blob地址
          a.href = URL.createObjectURL(blob)
          a.download = this.modulename // 下载文件的名字
          document.body.appendChild(a)
          a.click()
        })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    handleSortChange(val) {
      if (val.order == null) {
        //不排序
        this.order = ''
        this.orderType = ''
        this.getData()
      } else {
        this.order = val.prop
        if (val.order == 'descending') {
          this.orderType = 'desc'
        } else {
          this.orderType = 'asc'
        }
        this.getData()
      }
    },
    indexMethod(index) {
      return index + 1 + (this.pageNumber - 1) * pageSize
    },
    create(item) {
      let idStr = Date.now().toString(36)
      idStr += Math.random().toString(36).substr(3)
      return idStr
    },
    changeData() {
      this.getData()
    },
    getData() {
      this.loading = true
      let param = {
        token: this.token,
        checkCode: this.checkCode,
        listType: 'page',
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
        order: this.order,
        orderType: this.orderType,
        moduleid: this.moduleid,
        dBegin: this.$moment(this.tiemSlot[0]).format('YYYY-MM-DD'),
        dEnd: this.$moment(this.tiemSlot[1]).format('YYYY-MM-DD'),
        showzero: this.showzero,
      }
      API__DailyStatistic.getTbModuleDetails(param).then((res) => {
        this.loading = false
        this.list = res.data.data.list
        this.total = res.data.data.totalRow
        this.count = res.data.data.totalRow
      })
    },
    indexchange(index) {
      if (index == 0) {
        return 'contextEc1'
      } else if (index == 1) {
        return 'contextEc2'
      } else {
        if (index % 2 == 0) {
          return 'contextEc3'
        } else {
          return 'contextEc4'
        }
      }
    },
  },
}
</script>

<style scoped>
.searchName {
  padding-right: 20px;
  font-size: 14px;
  color: #666666;
}
.kuang {
  margin-right: 30px;
}
.message {
  color: #666666;
  line-height: 30px;
}
.contextEc {
  width: calc(50% - 10px);
  height: 265px;
  box-sizing: border-box;
  border-radius: 4px;
  float: left;
  border: 1px solid #ebebeb;
}
.contextEc2 {
  margin-left: 20px;
}
.contextEc3 {
  margin-top: 15px;
}
.contextEc4 {
  margin-top: 15px;
  margin-left: 20px;
}
.footer {
  clear: both;
  width: 100%;
  /* right: 40px;
  bottom: 60px; */
  /* position: absolute; */
  box-sizing: border-box;
  float: right;
  padding-top: 10px;
}
</style>



// WEBPACK FOOTER //
// moduleDetail.vue?067a2e30